/**
 * sheen-BE error JSON (Express): top-level `error` / `message` / `errors[]` / `code`.
 * After fetch `res.json()`, errors are NOT nested under `data` (unlike axios `error.response.data` in some setups).
 *
 * Recommended parse order:
 * 1. non-empty string `message`
 * 2. non-empty string `error`
 * 3. `errors[0].msg` or `errors[0].message` (express-validator)
 * 4. `code` (e.g. CANNOT_DELETE_ADMIN) → friendly text
 * 5. fallback: Request failed (status)
 */

const CANNOT_DELETE_ADMIN_TEXT = 'Admin accounts cannot be deleted.';

export function extractSheenBackendErrorMessage(body, httpStatus = 0) {
  if (body != null && typeof body === 'object') {
    if (typeof body.message === 'string') {
      const m = body.message.trim();
      if (m) return m;
    }
    if (typeof body.error === 'string') {
      const e = body.error.trim();
      if (e) return e;
    }
    if (Array.isArray(body.errors) && body.errors.length > 0) {
      for (const item of body.errors) {
        if (item && typeof item === 'object') {
          const v = item.msg ?? item.message;
          if (typeof v === 'string' && v.trim()) return v.trim();
        }
      }
    }
    if (typeof body.code === 'string' && body.code.trim()) {
      const c = body.code.trim();
      if (c === 'CANNOT_DELETE_ADMIN') {
        const again =
          (typeof body.message === 'string' && body.message.trim()) ||
          (typeof body.error === 'string' && body.error.trim());
        return again || CANNOT_DELETE_ADMIN_TEXT;
      }
      return c;
    }
  }
  if (typeof body === 'string' && body.trim()) return body.trim();
  return httpStatus ? `Request failed (${httpStatus})` : 'Request failed';
}

/** When `res.json()` may be object or plain text error page */
export function extractSheenBackendErrorMessageLoose(data, httpStatus = 0) {
  if (data != null && typeof data === 'object') {
    return extractSheenBackendErrorMessage(data, httpStatus);
  }
  if (typeof data === 'string' && data.trim()) return data.trim();
  return httpStatus ? `Request failed (${httpStatus})` : 'Request failed';
}
